import axios from "axios";

export const getOtpApi = (payload) => {
  const prodUrl = process.env.REACT_APP_BASE_URL;

  return axios
    .post(prodUrl + "user-service/api/v1/users/verify-otp/", {
      otp: payload.otp,
    })
    .then(function (response) {
      // console.log(response, "otp api response")
      return response;
    })
    .catch((error) => {
      return error;
    });
};
